<template>
  <page-title pageTitle="Add Item" :title="priceGroupName" />
  <price-group-item-form
    :priceGroup="{}"
    :submitFunction="addPriceGroupItem"
    :disabled-list="new Set(['barcode', 'costPrice', 'retailPrice'])"
  />
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import PriceGroupItemFormComponent from "@/components/priceGroup/PriceGroupItemForm";

export default {
  name: "AddPriceGroupItemView",
  components: {
    PageTitle: PageTitleComponent,
    PriceGroupItemForm: PriceGroupItemFormComponent,
  },
  data() {
    return {
      id: -1,
      priceGroup: null,
    };
  },
  computed: {
    error() {
      return this.$store.getters.billersError;
    },
    loading() {
      return this.$store.getters.billersLoading;
    },
    priceGroupName() {
      if (this.$store.getters.getPriceGroupByID(this.id)) {
        return this.$store.getters.getPriceGroupByID(this.id).name;
      }
      return "Customer Price Group";
    },
  },
  methods: {
    async addPriceGroupItem(priceGroupItem) {
      await this.$store.dispatch("addPriceGroupItem", priceGroupItem);
      this.$router.push(`/priceGroups/${priceGroupItem.priceGroupID}`);
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    let filter = {
      resultsPerPage: 1,
    };
    await this.$store.dispatch("getPriceGroups", filter);
  },
};
</script>

<style scoped></style>
